import api from '@api'
import { transformUserSecurity } from '@data/user-security'
import { isLoggedIn } from '@utils/auth'

export function getUserSecurityApi() {
  return api
    .get(`${isLoggedIn() ? '/' : '/public/'}usersecurity`)
    .then(transformUserSecurity)
}
